/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { IconButton, Tooltip } from '@mui/material';
import { coleccionInformeBienestar } from '../helper/coleccionCreditos';

import TableList from '../components/table-list';
import { MAIN_PATH, PATH_NAME } from '../constants';
import Iconify from '../components/iconify/Iconify';
import { cargarInformeAEditar, eliminarInformeBienestar } from '../store';

export function BienestarFinancieroGeneral() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [solicitudes, setSolicitudes] = useState({
    loading: true,
    data: [],
  });

  const { informes } = useSelector((state) => state.contadorInfor);
  console.log('🚀 ~ BienestarFinancieroGeneral ~ informes:', informes);

  useEffect(() => {
    setSolicitudes({
      loading: false,
      data: coleccionInformeBienestar(informes),
    });
  }, []);

  const redireccionarEdicion = (idInforme) => {
    const informe = informes.filter((informe) => informe.id === idInforme)[0];

    dispatch(cargarInformeAEditar(informe));
    navigate(`/admin/${MAIN_PATH}/${PATH_NAME.gestionar_informe}`, { replace: true });
  };

  const cancelarPeticion = (idInforme) => {
    dispatch(eliminarInformeBienestar(idInforme));
  };

  const columnas = [
    {
      label: 'Nombre',
      name: 'nombre',
      options: {
        filter: true,
      },
    },
    {
      label: 'Cédula',
      name: 'cedula',
      options: {
        filter: true,
      },
    },
    {
      label: 'N. Solicitud',
      name: 'id',
      options: {
        filter: true,
      },
    },
    // {
    //   label: 'Monto Aprobado',
    //   name: 'valorSolicitado',
    //   options: {
    //     filter: true,
    //   },
    // },
    {
      name: 'Gestionar',
      options: {
        sort: false,
        customBodyRender: (_value, tableMeta) => (
          <Tooltip title="Gestionar" aria-label="Gestionar">
            <IconButton aria-label="Gestionar" onClick={() => redireccionarEdicion(tableMeta.rowData[2])}>
              <Iconify icon="material-symbols:edit-square-outline" />
            </IconButton>
          </Tooltip>
        ),
      },
    },
    {
      name: 'Copiar',
      options: {
        sort: false,
        customBodyRender: (_value, tableMeta) => (
          <Tooltip title="Copiar Cédula">
            <IconButton
              aria-label="Copiar"
              onClick={() => navigator.clipboard.writeText(tableMeta.rowData[1].replaceAll('.', ''))}
            >
              <Iconify icon="mdi-light:clipboard-text" />
            </IconButton>
          </Tooltip>
        ),
      },
    },
    {
      name: 'Cancelar',
      options: {
        sort: false,
        customBodyRender: (_value, tableMeta) => (
          <Tooltip title="Cancelar Petición">
            <IconButton
              aria-label="Cancelar"
              color="error"
              onClick={() => cancelarPeticion(tableMeta.rowData[2])}
            >
              <Iconify icon="mdi:delete-outline" />
            </IconButton>
          </Tooltip>
        ),
      },
    },
  ];
  return (
    <>
      <Helmet>
        <title> Informes de Bienestar Financiero General</title>
      </Helmet>

      <TableList
        titulo="Informe Bienestar Financiero"
        columnas={columnas}
        loading={solicitudes.loading}
        data={solicitudes.data}
      />
    </>
  );
}
